"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MobileNav = require("./MobileNav.style");
var _LanguageDropDown = _interopRequireDefault(require("./LanguageDropDown"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var MenuNoJs = function MenuNoJs(_ref) {
  var toggleButtonId = _ref.toggleButtonId,
    dataKeyBase = _ref.dataKeyBase,
    languageLinks = _ref.languageLinks,
    activeLanguage = _ref.activeLanguage,
    mobileLinks = _ref.mobileLinks;
  return /*#__PURE__*/_react.default.createElement(_MobileNav.ControlNav, {
    "aria-controls": toggleButtonId,
    "aria-label": "Toggle Mobile Navigation",
    "data-key": "max-top-nav--mobile__menu-toggle"
  }, /*#__PURE__*/_react.default.createElement(_MobileNav.Input, {
    type: "checkbox"
  }), /*#__PURE__*/_react.default.createElement(_MobileNav.Line, null), /*#__PURE__*/_react.default.createElement(_MobileNav.Line, null), /*#__PURE__*/_react.default.createElement(_MobileNav.Line, null), /*#__PURE__*/_react.default.createElement(_MobileNav.ModalContainer, null, /*#__PURE__*/_react.default.createElement(_MobileNav.ModalContent, {
    "data-key": "".concat(dataKeyBase, "--mobile")
  }, mobileLinks.map(function (link, parentIndex) {
    if (!link.dropdown) {
      return /*#__PURE__*/_react.default.createElement(_MobileNav.NavItem, {
        key: "mobile-nav-item-".concat(link.props.children).concat(parentIndex),
        "data-key": "".concat(dataKeyBase, "-").concat(parentIndex)
      }, link);
    } else {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "".concat(dataKeyBase, "-").concat(parentIndex, "--dropdown"),
        "data-key": "".concat(dataKeyBase, "-").concat(parentIndex, "--dropdown")
      }, /*#__PURE__*/_react.default.createElement(_MobileNav.StyledExpander, {
        border: false,
        title: link.link.props.children
      }, /*#__PURE__*/_react.default.createElement(_MobileNav.MobileSubLinks, {
        "data-key": "".concat(dataKeyBase, "-").concat(parentIndex, "--sub-links")
      }, link.subLinks.map(function (subLink, subIndex) {
        return /*#__PURE__*/_react.default.createElement(_MobileNav.SubNavItem, {
          subLink: true,
          key: "sub-nav-item-".concat(parentIndex).concat(subIndex),
          "data-key": "".concat(dataKeyBase, "-").concat(parentIndex, "-sub-item-").concat(subIndex)
        }, subLink);
      }))));
    }
  }), languageLinks && languageLinks.length > 1 && /*#__PURE__*/_react.default.createElement(_LanguageDropDown.default, {
    languageLinks: languageLinks,
    activeLanguage: activeLanguage
  }))));
};
var _default = MenuNoJs;
exports.default = _default;